import useProfile from './useProfile';

export default useProfile;
